// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_km-0";